'use strict';

export class Dialog {
	static initialized = false;
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.$dialog = jQuery(`.js-${this.id}`);
		if (this.component.trigger) {
			this.$trigger = jQuery(`.${this.component.trigger}`);
		}
	}
	init() {
		if (!Dialog.initialized) {
			Dialog.initialized = true;
			this.init_once();
		}
	}
	async init_once() {
		const promises = Object.keys(yalwa.v.components).map(async component_key => {
			const component = yalwa.v.components[component_key];
			if (component_key.startsWith('dialog_')) {
				try {
					const class_name = yalwa.basics.to_pascal_case(component_key);
					// import
					const module = await import(`./${component_key}.js`);
					// instantiate and initialize
					const component_class = module[class_name];
					const instance = new component_class(component_key);
					//Making it available in public
					(yalwa.v ??= {}).components ??= {};
					yalwa.v.components.initialized ??= {};
					yalwa.v.components.initialized[component_key] = instance;
					if (component.default_visible) {
						yalwa.v.dialog_queue.push(instance); // other dialogs with default visible value
					} else {
						instance.load();
					}
				} catch (error) {
					console.error(`Failed to load or initialize class for ${component_key}:`, error);
				}
			}
		})
		// Wait for all promises to resolve
		await Promise.all(promises);
		this.prepare_queue();
		this.check_queue();
	}
	load() {
		this.add_events();
		return this;
	}
	
	check_queue() {
		if (yalwa.v.dialog_queue[0]) {
			const dialog = yalwa.v.dialog_queue.shift();
			dialog.load().show();
		}
	}
	add_events() {
		// Generic close event
		if(this.$dialog.hasClass(`js-${this.component.component_type}_close`)) {
			this.$dialog.off('click.close').on('click.close', (e) => {
				// Only close if the click was directly on the background overlay, not bubbled from content
				if (e.target === e.currentTarget || jQuery(e.target).hasClass('dialog__position')) {
					this.hide();
				}
			});
		}
		if (this.$trigger) {
			this.$trigger.on('click', this.show.bind(this));
		}
		this.$dialog.find(`.js-${this.component.component_type}_close`).off('click.close').on('click.close', this.hide.bind(this));
	}
	hide() {
		yalwa.basics.hide(this.$dialog);
		yalwa.basics.bem_modifier(jQuery('.js-mbody'), 'gs_showing', 'remove');
		this.on_close();
		this.check_queue();
	}
	on_close() {
		//do nothing by default
	}
	on_show() {
		//do nothing by default
	}
	show() {
		yalwa.basics.show(this.$dialog);
		yalwa.basics.bem_modifier(jQuery('.js-mbody'), 'gs_showing', 'add');
		this.on_show();
	}
	prepare_queue() {
		[...yalwa.v.dialog_queue.entries()]
			.sort(([, a], [, b]) => {
				return a.component.priority - b.component.priority;
			})
			.forEach(([key, value], index) => {
				yalwa.v.dialog_queue[index] = value;
				if (index !== 0) {
					yalwa.basics.hide(yalwa.v.dialog_queue[index].$dialog);
				}
			});
	}
}

yalwa.v.dialog_queue = [];
